"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const moment_1 = __importDefault(require("moment"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const material_ui_confirm_1 = require("material-ui-confirm");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1() {
    const [{ total_withdrawable_amount, total_reward_amount }, setSettlementTotalAmount] = (0, recoil_1.useRecoilState)(settlementManageState_1.settlementTotalAmountState);
    const isTotalWithdrawable = Boolean(total_withdrawable_amount);
    const isTotalRewardNone = total_reward_amount === 0;
    const { id: roomId, room_status_cd, settlement_list, } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementDetailsDataState);
    const isBuyerInfoDiscarded = room_status_cd === 'ROOM_STATUS_06';
    const isAlreadyRewarded = settlement_list.some(list => list.is_reward &&
        ((list.is_approved && list.is_processed) || (!list.is_approved && !list.is_processed)));
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const pendingRef = (0, react_1.useRef)(false);
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const disablePending = () => {
        pendingRef.current = false;
        if (!unmountRef.current) {
            setIsPending(false);
        }
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onRewardShareClick = () => {
        if (!pendingRef.current) {
            confirm({
                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('사비지킴이 전액을'), (0, jsx_runtime_1.jsx)("br", {}), t('모든 구매자의 지갑으로 나눔하시겠어요?')] })),
                confirmationText: t('전액 나눔'),
            })
                .then(() => __awaiter(this, void 0, void 0, function* () {
                pendingRef.current = true;
                setIsPending(true);
                yield (0, api_1.patchData)(`/api/v1/room/${roomId}/settlement/reward-share`, {})
                    .then(() => {
                    (0, functions_1.showToastMessage)({ message: t('구매자 나눔 완료') });
                    setSettlementTotalAmount(prev => (Object.assign(Object.assign({}, prev), { total_reward_amount: 0 })));
                })
                    .catch(err => {
                    var _a, _b;
                    const { status } = err.response;
                    if (status === 403)
                        (0, errors_1.handle403Error)(err);
                    else if (status === 400) {
                        const alertType = ((_b = (_a = err.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type) || 0;
                        if (alertType === 40006) {
                            const reloadPage = () => window.location.reload();
                            confirm({
                                description: t('전액 나눔이 진행중이에요!'),
                                cancellationButtonProps: { style: { display: 'none' } },
                            })
                                .then(reloadPage)
                                .catch(reloadPage);
                        }
                        else {
                            const yymmdd = (0, moment_1.default)().format('YYMMDD');
                            confirm({
                                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('화면을 캡쳐하여 1:1 문의하기 해주세요.'), (0, jsx_runtime_1.jsx)("br", {}), `${t('접수 번호')}: ${yymmdd}${alertType}`] })),
                                confirmationText: t('1:1 문의하기'),
                            })
                                .then(() => (window.location.href = '/fondee/qna'))
                                .catch(() => { });
                        }
                    }
                    else
                        alert((0, errors_1.commonErrorMsg)(status));
                })
                    .finally(disablePending);
            }))
                .catch(() => { });
        }
    };
    return ((0, jsx_runtime_1.jsx)(_1.SettlementButton, Object.assign({ disabled: isTotalWithdrawable || isTotalRewardNone || !isBuyerInfoDiscarded || isAlreadyRewarded, onClick: onRewardShareClick }, { children: isPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 8 })) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('전액 나눔') }))) })));
}
exports.default = default_1;
